/* Three.js scene and models */
// ...existing code from index.html scene initialization, loaders, and animate...
// This file extracted from inline script. The content below mirrors the scene-related code.
let scene, camera, renderer, objects = [];
let relayoutScene = null;
let rafId = null;
// 機器人頭部追蹤滑鼠：Bone005 為頭部骨頭（實測確認），記錄 rest pose 後疊加偏移
let robotHead = null, robotHeadRest = null, headYaw = 0, headPitch = 0;
// hover 球體時的肢體反應：Bone011 = 機器人自身的右手 = 畫面左側、
// 靠近球體的那隻（scale-0 隱藏法實測確認；Bone026 是畫面右側）。
// 骨骼局部歐拉軸經父鏈旋轉後不可靠，改用四元數繞「世界 Z 軸」旋轉，
// 負角 = 向左上舉起，−0.6 過肩、−1.0 貼頭（乾淨協定實測）。
// 頭部 z 軸增量 = 向球側歪頭
let robotArm = null, robotArmRest = null, armRaise = 0, headTilt = 0;
// 表情切換：臉部五官畫在身體共用貼圖的臉部格子上（實測），hover 時
// 以 canvas 將眨眼（左）換成鏡射的圓眼（右）= 雙圓眼開心表情。
// 座標為 4096 貼圖上的實測框：圓眼 (1663,218,77,84)、貼上位置 x=1464 同列
let robotBodyMat = null, robotFaceTexBase = null, robotFaceTexHappy = null, faceHappy = false;
let sharedRobotAccentTex = null;
const MOBILE_LAYOUT_QUERY = '(max-width: 768px), (max-width: 1024px) and (orientation: portrait)';
let useMobileComposition = window.matchMedia(MOBILE_LAYOUT_QUERY).matches;
const armParentQ = new THREE.Quaternion();
const armAxis = new THREE.Vector3();
const armRot = new THREE.Quaternion();
// 服務節點 hover 互動：raycast 命中後微幅放大 + 邊框增亮
let techSpheres = [];
const raycaster = new THREE.Raycaster();
// 觸控互動：粗指標裝置以「點擊球體」取代 hover，反應維持 2.5 秒後復原；
// 點擊空白處立即復原，頭部與視差同步看向觸點
const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
let touchHitMesh = null, touchExpireAt = 0;
const touchNdc = new THREE.Vector2();
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const deviceMemory = navigator.deviceMemory || 4;
const hardwareConcurrency = navigator.hardwareConcurrency || 4;
const isMobileViewport = window.matchMedia(MOBILE_LAYOUT_QUERY).matches;
// 低階或記憶體較小的裝置自動採用精簡材質管線，桌機與較新手機保留完整質感。
const isLowPowerDevice = deviceMemory <= 2 || hardwareConcurrency <= 4 ||
    (isMobileViewport && deviceMemory <= 4);
let mouse = new THREE.Vector2(), targetRotation = new THREE.Vector2();
let hologramGroup = null, hologramMat = null, hologramFrameMat = null, hologramGlowMat = null, hologramBeamMat = null;
let hologramBeam = null, hologramPanelScale = 1;
let hologramCanvas = null, hologramCtx = null, hologramTexture = null;
let activeProjection = null, projectionAmount = 0;
let drawHologram = null, updateHologramBeam = null;
const SERVICE_PRESENTATIONS = {
    'AI': {
        eyebrow: 'AI INTELLIGENCE',
        title: 'AI 智慧應用',
        lines: ['生成式 AI × 流程自動化', '強化知識、客服與決策效率'],
        meta: 'HUMAN-IN-THE-LOOP',
        arm: 0.84, tilt: 0.12, happy: true
    },
    '網站': {
        eyebrow: 'WEB EXPERIENCE',
        title: '客製網站製作',
        lines: ['品牌體驗、內容管理與效能兼顧', '打造能持續成長的數位門面'],
        meta: 'UX / CMS / PERFORMANCE',
        arm: 0.62, tilt: -0.12, happy: true
    },
    '系統': {
        eyebrow: 'SYSTEM ENGINEERING',
        title: '企業系統開發',
        lines: ['依流程打造穩定、可擴充的平台', '串接資料與既有營運工具'],
        meta: 'API / WORKFLOW / SCALE',
        arm: 0.74, tilt: 0.04, happy: false
    },
    '數據': {
        eyebrow: 'DATA INSIGHT',
        title: '數據洞察',
        lines: ['整合資料、儀表板與預測模型', '讓營運決策有更清晰的依據'],
        meta: 'BI / FORECAST / INSIGHT',
        arm: 0.55, tilt: -0.08, happy: false
    },
    '資安': {
        eyebrow: 'CYBER SECURITY',
        title: '資安防護',
        lines: ['從架構、權限到持續監控', '守住系統與企業重要資料'],
        meta: 'ISO 27001 / ZERO TRUST',
        arm: 0.78, tilt: 0, happy: false
    },
    '維運': {
        eyebrow: 'MANAGED SERVICE',
        title: '系統維運',
        lines: ['監控、備援與持續優化並行', '維持服務穩定與長期可用'],
        meta: 'MONITOR / BACKUP / SUPPORT',
        arm: 0.48, tilt: 0.15, happy: false
    }
};
let lastServiceDetailAt = 0;

function emitServiceDetail(hitMesh) {
    if (!hitMesh || !window.matchMedia(MOBILE_LAYOUT_QUERY).matches) return;
    const selected = techSpheres.find((item) => item.hitMesh === hitMesh);
    const presentation = selected && SERVICE_PRESENTATIONS[selected.service];
    if (!selected || !presentation) return;
    const now = Date.now();
    if (now - lastServiceDetailAt < 420) return;
    lastServiceDetailAt = now;
    window.dispatchEvent(new CustomEvent('service-detail', {
        detail: {
            service: selected.service,
            eyebrow: presentation.eyebrow,
            title: presentation.title,
            lines: presentation.lines.slice(),
            meta: presentation.meta
        }
    }));
}

const loader = new THREE.GLTFLoader();
// robot.glb 使用 KHR_draco_mesh_compression，需掛上 DRACOLoader
if (THREE.DRACOLoader) {
    const dracoLoader = new THREE.DRACOLoader();
    dracoLoader.setDecoderPath('./js/draco/');
    loader.setDRACOLoader(dracoLoader);
}

function init() {
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);
    // camera.position.z set below based on mobile detection
    renderer = new THREE.WebGLRenderer({ antialias: !isLowPowerDevice, alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, isLowPowerDevice ? 1.25 : 2));
    // r128 的 API 是 outputEncoding（outputColorSpace 為 r152+），robot 貼圖需要 sRGB 輸出
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.78;
    document.getElementById('container').appendChild(renderer.domElement);

    // 以程式建立柔和攝影棚環境貼圖，讓白色外殼產生受控反射與明暗層次，
    // 保留 RURU 造型但避免像單一純白塑膠。
    function createStudioEnvironment() {
        function createFace(lightX, lightY, highlight) {
            const canvas = document.createElement('canvas');
            const environmentSize = isLowPowerDevice ? 64 : 128;
            canvas.width = environmentSize;
            canvas.height = environmentSize;
            const ctx = canvas.getContext('2d');
            const base = ctx.createLinearGradient(0, 0, environmentSize, environmentSize);
            base.addColorStop(0, '#13283d');
            base.addColorStop(0.55, '#071426');
            base.addColorStop(1, '#020712');
            ctx.fillStyle = base;
            ctx.fillRect(0, 0, environmentSize, environmentSize);
            const ratio = environmentSize / 128;
            const glow = ctx.createRadialGradient(lightX * ratio, lightY * ratio, 2, lightX * ratio, lightY * ratio, 86 * ratio);
            glow.addColorStop(0, highlight);
            glow.addColorStop(0.26, 'rgba(115, 190, 224, 0.42)');
            glow.addColorStop(1, 'rgba(5, 15, 30, 0)');
            ctx.globalCompositeOperation = 'screen';
            ctx.fillStyle = glow;
            ctx.fillRect(0, 0, environmentSize, environmentSize);
            return canvas;
        }
        const cube = new THREE.CubeTexture([
            createFace(30, 38, 'rgba(220, 244, 255, 0.9)'),
            createFace(96, 68, 'rgba(70, 146, 188, 0.62)'),
            createFace(50, 18, 'rgba(239, 250, 255, 0.92)'),
            createFace(72, 108, 'rgba(25, 74, 105, 0.46)'),
            createFace(28, 42, 'rgba(176, 225, 247, 0.78)'),
            createFace(104, 62, 'rgba(43, 131, 173, 0.54)')
        ]);
        cube.encoding = THREE.sRGBEncoding;
        cube.needsUpdate = true;
        if (isLowPowerDevice) {
            scene.environment = cube;
        } else {
            const pmrem = new THREE.PMREMGenerator(renderer);
            pmrem.compileCubemapShader();
            scene.environment = pmrem.fromCubemap(cube).texture;
            cube.dispose();
            pmrem.dispose();
        }
    }
    createStudioEnvironment();

    // 為主外殼建立細緻、可重複的微表面，不依賴額外圖片請求。
    // bump 提供近看時的塗裝顆粒，roughness 讓反光不再整片同亮。
    function createShellSurfaceTextures() {
        const size = isLowPowerDevice ? 96 : 192;
        const bumpCanvas = document.createElement('canvas');
        const roughCanvas = document.createElement('canvas');
        bumpCanvas.width = bumpCanvas.height = size;
        roughCanvas.width = roughCanvas.height = size;
        const bumpCtx = bumpCanvas.getContext('2d');
        const roughCtx = roughCanvas.getContext('2d');
        const bumpImage = bumpCtx.createImageData(size, size);
        const roughImage = roughCtx.createImageData(size, size);
        let seed = 0x6D2B79F5;
        function random() {
            seed = (seed + 0x6D2B79F5) | 0;
            let value = Math.imul(seed ^ (seed >>> 15), 1 | seed);
            value ^= value + Math.imul(value ^ (value >>> 7), 61 | value);
            return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
        }
        for (let y = 0; y < size; y++) {
            for (let x = 0; x < size; x++) {
                const index = (y * size + x) * 4;
                const grain = (random() - 0.5) * 22;
                const brushed = Math.sin((x + y * 0.35) * 0.16) * 2.5;
                const bumpValue = Math.max(98, Math.min(158, 128 + grain + brushed));
                const roughValue = Math.max(172, Math.min(236, 207 - grain * 0.85 + brushed * 2));
                bumpImage.data[index] = bumpImage.data[index + 1] = bumpImage.data[index + 2] = bumpValue;
                roughImage.data[index] = roughImage.data[index + 1] = roughImage.data[index + 2] = roughValue;
                bumpImage.data[index + 3] = roughImage.data[index + 3] = 255;
            }
        }
        bumpCtx.putImageData(bumpImage, 0, 0);
        roughCtx.putImageData(roughImage, 0, 0);
        const bumpTexture = new THREE.CanvasTexture(bumpCanvas);
        const roughnessTexture = new THREE.CanvasTexture(roughCanvas);
        [bumpTexture, roughnessTexture].forEach((texture) => {
            texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
            texture.repeat.set(6, 6);
            texture.anisotropy = isLowPowerDevice ? 1 : Math.min(4, renderer.capabilities.getMaxAnisotropy());
            texture.needsUpdate = true;
        });
        return { bumpTexture, roughnessTexture };
    }
    const shellSurface = createShellSurfaceTextures();

    // 服務節點改為深色 HUD 資訊卡：降低「糖果玻璃球」的玩具感，
    // 以細框、狀態點和英文代碼建立企業級數位介面語言。
    function createTechSphere(text, x, y, scale = 1, fontSize = 85, rotation = { x: 0, y: 0, z: 0 }, opacity = 0.3, emissiveInt = 0.2) {
        const group = new THREE.Group();
        const nodeCodes = { 'AI': 'INTELLIGENCE', '網站': 'WEB', '系統': 'SYSTEM', '數據': 'DATA', '資安': 'SECURITY', '維運': 'OPS' };
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 768; canvas.height = 256;
        ctx.beginPath();
        ctx.roundRect(8, 8, 752, 240, 28);
        ctx.fillStyle = 'rgba(5, 19, 39, 0.9)';
        ctx.fill();
        ctx.lineWidth = 4;
        ctx.strokeStyle = 'rgba(104, 202, 244, 0.92)';
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(54, 128, 11, 0, Math.PI * 2);
        ctx.fillStyle = '#B4D333';
        ctx.shadowColor = 'rgba(180, 211, 51, 0.8)';
        ctx.shadowBlur = 18;
        ctx.fill();
        ctx.shadowBlur = 0;
        ctx.fillStyle = '#F4F8FB';
        const labelFontSize = currentMobile ? 108 : 82;
        ctx.font = `700 ${labelFontSize}px "Noto Sans TC", "PingFang TC", "Microsoft JhengHei", Arial`;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, 92, 112);
        ctx.fillStyle = 'rgba(147, 190, 216, 0.72)';
        ctx.font = `600 ${currentMobile ? 30 : 25}px Orbitron, Arial`;
        ctx.letterSpacing = '3px';
        ctx.fillText(nodeCodes[text] || text, 94, 187);
        const texture = new THREE.CanvasTexture(canvas);
        texture.encoding = THREE.sRGBEncoding;
        const coreMat = new THREE.MeshBasicMaterial({
            map: texture, transparent: true, opacity: 0.94,
            side: THREE.DoubleSide, depthWrite: false
        });
        const panelGeo = new THREE.PlaneGeometry(1.82 * scale, 0.62 * scale);
        const panel = new THREE.Mesh(panelGeo, coreMat);
        panel.renderOrder = 998;
        group.add(panel);
        const rimMat = new THREE.LineBasicMaterial({
            color: 0x62C4F0, transparent: true,
            opacity: Math.min(0.9, 0.42 + opacity * 0.48)
        });
        const frame = new THREE.LineSegments(new THREE.EdgesGeometry(panelGeo), rimMat);
        frame.position.z = 0.002;
        frame.renderOrder = 999;
        group.add(frame);
        const hitMat = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0, depthWrite: false });
        const hitMesh = new THREE.Mesh(panelGeo, hitMat);
        hitMesh.position.z = 0.008;
        group.add(hitMesh);
        group.position.set(x, y, 0);
        scene.add(group);
        objects.push({ mesh: group, baseY: y, offset: Math.random() * 10 });
        techSpheres.push({
            service: text,
            group: group, hitMesh: hitMesh, coreMat: coreMat, rimMat: rimMat,
            baseCoreOpacity: 0.94, baseRimAlpha: rimMat.opacity, hover: 0
        });
    }

    // 滑過服務節點時展開的 3D 科技投影面板；內容以 canvas 即時繪製，
    // 不增加圖片請求，並能在六項服務之間立即切換。
    function createHologramPanel(x, y, scale) {
        hologramCanvas = document.createElement('canvas');
        hologramCanvas.width = 1024;
        hologramCanvas.height = 512;
        hologramCtx = hologramCanvas.getContext('2d');
        hologramTexture = new THREE.CanvasTexture(hologramCanvas);
        hologramTexture.encoding = THREE.sRGBEncoding;
        hologramMat = new THREE.MeshBasicMaterial({
            map: hologramTexture,
            transparent: true,
            opacity: 0,
            depthWrite: false,
            depthTest: false,
            side: THREE.DoubleSide
        });
        const panelGeo = new THREE.PlaneGeometry(2.9 * scale, 1.45 * scale);
        const panel = new THREE.Mesh(panelGeo, hologramMat);
        panel.renderOrder = 1004;

        hologramFrameMat = new THREE.LineBasicMaterial({
            color: 0x75D5F8,
            transparent: true,
            opacity: 0,
            depthTest: false
        });
        const frame = new THREE.LineSegments(new THREE.EdgesGeometry(panelGeo), hologramFrameMat);
        frame.position.z = 0.004;
        frame.renderOrder = 1005;

        hologramGlowMat = new THREE.MeshBasicMaterial({
            color: 0x1A8FC3,
            transparent: true,
            opacity: 0,
            blending: THREE.AdditiveBlending,
            depthWrite: false,
            depthTest: false
        });
        const glow = new THREE.Mesh(new THREE.PlaneGeometry(3.08 * scale, 1.63 * scale), hologramGlowMat);
        glow.position.z = -0.012;
        glow.renderOrder = 1003;

        // 從 RURU 方向展開的克制藍色投影光束。以透明漸層、掃描帶與微粒
        // 提示「正在投影」，並放在 z 後方，避免覆蓋機器人與服務按鈕。
        const beamCanvas = document.createElement('canvas');
        beamCanvas.width = 512;
        beamCanvas.height = 512;
        const beamCtx = beamCanvas.getContext('2d');
        const beamGradient = beamCtx.createLinearGradient(0, beamCanvas.height, 0, 0);
        beamGradient.addColorStop(0, 'rgba(69, 195, 255, 0)');
        beamGradient.addColorStop(0.18, 'rgba(69, 195, 255, 0.4)');
        beamGradient.addColorStop(0.72, 'rgba(68, 183, 240, 0.22)');
        beamGradient.addColorStop(1, 'rgba(68, 183, 240, 0)');
        beamCtx.beginPath();
        beamCtx.moveTo(150, 500);
        beamCtx.lineTo(28, 14);
        beamCtx.lineTo(494, 14);
        beamCtx.closePath();
        beamCtx.fillStyle = beamGradient;
        beamCtx.fill();
        beamCtx.save();
        beamCtx.clip();
        beamCtx.strokeStyle = 'rgba(135, 224, 255, 0.15)';
        beamCtx.lineWidth = 2;
        for (let beamY = 52; beamY < 470; beamY += 44) {
            beamCtx.beginPath();
            beamCtx.moveTo(45, beamY);
            beamCtx.lineTo(484, beamY);
            beamCtx.stroke();
        }
        beamCtx.fillStyle = 'rgba(167, 232, 255, 0.48)';
        for (let i = 0; i < 34; i++) {
            const px = 70 + ((i * 83) % 380);
            const py = 40 + ((i * 127) % 420);
            const radius = 1 + (i % 3) * 0.55;
            beamCtx.beginPath();
            beamCtx.arc(px, py, radius, 0, Math.PI * 2);
            beamCtx.fill();
        }
        beamCtx.restore();
        beamCtx.beginPath();
        beamCtx.moveTo(150, 500);
        beamCtx.lineTo(28, 14);
        beamCtx.moveTo(150, 500);
        beamCtx.lineTo(494, 14);
        beamCtx.strokeStyle = 'rgba(126, 220, 255, 0.24)';
        beamCtx.lineWidth = 3;
        beamCtx.stroke();
        const beamTexture = new THREE.CanvasTexture(beamCanvas);
        beamTexture.encoding = THREE.sRGBEncoding;
        hologramBeamMat = new THREE.MeshBasicMaterial({
            map: beamTexture,
            transparent: true,
            opacity: 0,
            blending: THREE.AdditiveBlending,
            depthWrite: false,
            depthTest: true,
            side: THREE.DoubleSide
        });
        const beamGeo = new THREE.BufferGeometry();
        beamGeo.setAttribute('position', new THREE.Float32BufferAttribute([
            0, 0, -0.42,
            0, 0, -0.42,
            0, 0, -0.42
        ], 3));
        beamGeo.setAttribute('uv', new THREE.Float32BufferAttribute([
            150 / 512, 0,
            28 / 512, 1,
            494 / 512, 1
        ], 2));
        hologramBeam = new THREE.Mesh(beamGeo, hologramBeamMat);
        hologramBeam.renderOrder = 996;
        hologramPanelScale = scale;

        hologramGroup = new THREE.Group();
        hologramGroup.add(hologramBeam, glow, panel, frame);
        hologramGroup.position.set(x, y, 0.12);
        hologramGroup.scale.set(0.94, 0.94, 0.94);
        scene.add(hologramGroup);
        objects.push({ mesh: hologramGroup, baseY: y, offset: 0, isStatic: true });

        // 光束起點跟著目前互動的服務按鈕，終點固定落在投影面板下緣。
        // 服務卡與機器人位於較前方的 z 軸，光束不會蓋住內容。
        updateHologramBeam = function (service, groupScale) {
            if (!hologramBeam || !hologramGroup) return;
            const source = techSpheres.find((item) => item.service === service);
            if (!source) return;
            const safeScale = Math.max(groupScale || 1, 0.01);
            const apexX = (source.group.position.x - hologramGroup.position.x) / safeScale;
            const apexY = (source.group.position.y - hologramGroup.position.y) / safeScale;
            const panelHalfWidth = 2.9 * hologramPanelScale * 0.42;
            const panelBottom = -1.45 * hologramPanelScale * 0.42;
            const position = hologramBeam.geometry.getAttribute('position');
            position.setXYZ(0, apexX, apexY, -0.42);
            position.setXYZ(1, -panelHalfWidth, panelBottom, -0.42);
            position.setXYZ(2, panelHalfWidth, panelBottom, -0.42);
            position.needsUpdate = true;
            hologramBeam.geometry.computeBoundingSphere();
        };
    }

    drawHologram = function (service) {
        const data = SERVICE_PRESENTATIONS[service];
        if (!data || !hologramCtx || !hologramTexture) return;
        const ctx = hologramCtx;
        const w = hologramCanvas.width;
        const h = hologramCanvas.height;
        ctx.clearRect(0, 0, w, h);

        const panelGradient = ctx.createLinearGradient(0, 0, w, h);
        panelGradient.addColorStop(0, 'rgba(4, 23, 45, 0.96)');
        panelGradient.addColorStop(0.55, 'rgba(5, 37, 63, 0.9)');
        panelGradient.addColorStop(1, 'rgba(4, 18, 37, 0.96)');
        ctx.beginPath();
        ctx.roundRect(12, 12, w - 24, h - 24, 30);
        ctx.fillStyle = panelGradient;
        ctx.fill();
        ctx.lineWidth = 4;
        ctx.strokeStyle = 'rgba(111, 211, 248, 0.9)';
        ctx.stroke();

        ctx.save();
        ctx.globalAlpha = 0.16;
        ctx.strokeStyle = '#74D7FA';
        ctx.lineWidth = 1;
        for (let scanY = 36; scanY < h - 28; scanY += 18) {
            ctx.beginPath();
            ctx.moveTo(32, scanY);
            ctx.lineTo(w - 32, scanY);
            ctx.stroke();
        }
        ctx.restore();

        ctx.fillStyle = '#B4D333';
        ctx.fillRect(48, 53, 8, 44);
        ctx.fillStyle = 'rgba(155, 213, 240, 0.82)';
        ctx.font = '600 25px Orbitron, Arial';
        ctx.letterSpacing = '4px';
        ctx.fillText(data.eyebrow, 82, 81);

        ctx.fillStyle = '#F3FAFF';
        ctx.font = '700 66px "Noto Sans TC", "PingFang TC", "Microsoft JhengHei", sans-serif';
        ctx.letterSpacing = '1px';
        ctx.fillText(data.title, 48, 176);

        ctx.fillStyle = 'rgba(217, 236, 246, 0.88)';
        ctx.font = '500 34px "Noto Sans TC", "PingFang TC", "Microsoft JhengHei", sans-serif';
        ctx.fillText(data.lines[0], 49, 257);
        ctx.fillText(data.lines[1], 49, 311);

        const metaWidth = Math.min(500, 70 + ctx.measureText(data.meta).width);
        ctx.beginPath();
        ctx.roundRect(48, 372, metaWidth, 64, 12);
        ctx.fillStyle = 'rgba(29, 112, 151, 0.28)';
        ctx.fill();
        ctx.strokeStyle = 'rgba(96, 198, 236, 0.55)';
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.fillStyle = '#A8E3F7';
        ctx.font = '600 24px Orbitron, Arial';
        ctx.letterSpacing = '2px';
        ctx.fillText(data.meta, 75, 413);

        ctx.fillStyle = 'rgba(171, 222, 245, 0.6)';
        ctx.font = '500 18px Orbitron, Arial';
        ctx.letterSpacing = '2px';
        const liveLabel = 'LIVE SERVICE DATA';
        const liveLabelX = w - 48 - ctx.measureText(liveLabel).width;
        ctx.fillStyle = '#B4D333';
        ctx.beginPath();
        ctx.arc(liveLabelX - 22, 69, 7, 0, Math.PI * 2);
        ctx.fill();
        ctx.fillStyle = 'rgba(171, 222, 245, 0.6)';
        ctx.fillText(liveLabel, liveLabelX, 76);

        hologramTexture.needsUpdate = true;
        activeProjection = service;
    };


    // 產生「雙圓眼開心」貼圖：複製整張貼圖後，把圓眼水平鏡射蓋到
    // 眨眼位置（兩者同列，垂直漸層背景一致，覆蓋無縫）
    function buildHappyTexture(baseTex) {
        const img = baseTex.image;
        if (!img || !img.width) return null;
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        // 臉部 UV 對應右上格（色塊實驗確認；中格與大格僅為素材參考）。
        // 圓眼框 (2566,232,68,72)，鏡射蓋到眨眼位置（中心 x≈2406，同列漸層無縫）
        const s = img.width / 4096;
        ctx.save();
        ctx.translate((2372 + 68) * s, 232 * s);
        ctx.scale(-1, 1);
        ctx.drawImage(img, 2566 * s, 232 * s, 68 * s, 72 * s, 0, 0, 68 * s, 72 * s);
        ctx.restore();
        const tex = new THREE.CanvasTexture(canvas);
        tex.flipY = false;
        tex.encoding = THREE.sRGBEncoding;
        tex.wrapS = baseTex.wrapS;
        tex.wrapT = baseTex.wrapT;
        tex.anisotropy = baseTex.anisotropy;
        return tex;
    }

    // 從主貼圖挑出青色燈帶，製成低解析度 emissive map。
    // 白色外殼保持受光材質，只有接縫、天線與臉部燈號產生微弱自發光。
    function buildAccentEmissionTexture(baseTex) {
        if (sharedRobotAccentTex) return sharedRobotAccentTex;
        const img = baseTex && baseTex.image;
        if (!img || !img.width) return null;
        const canvas = document.createElement('canvas');
        canvas.width = 1024;
        canvas.height = Math.max(256, Math.round(1024 * img.height / img.width));
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const pixels = imageData.data;
        for (let i = 0; i < pixels.length; i += 4) {
            const r = pixels[i];
            const g = pixels[i + 1];
            const b = pixels[i + 2];
            const cyanChroma = Math.min(g, b) - r;
            const value = (b > 125 && g > 105 && cyanChroma > 24)
                ? Math.min(255, (cyanChroma - 18) * 4.2)
                : 0;
            pixels[i] = pixels[i + 1] = pixels[i + 2] = value;
            pixels[i + 3] = 255;
        }
        ctx.putImageData(imageData, 0, 0);
        const texture = new THREE.CanvasTexture(canvas);
        texture.flipY = baseTex.flipY;
        texture.encoding = THREE.sRGBEncoding;
        texture.wrapS = baseTex.wrapS;
        texture.wrapT = baseTex.wrapT;
        texture.anisotropy = baseTex.anisotropy;
        texture.needsUpdate = true;
        sharedRobotAccentTex = texture;
        return texture;
    }

    // 主角機器人：多網格骨架模型，處理方式比照 exhibition.js。
    // 注意：glb 內建動畫是展場導覽用的姿勢動畫，播放會把身體移出畫面，不可播；
    // 漂浮感由 objects[] 的 float 機制提供
    function loadRobot(x, y, scale) {
        const version = layoutVersion;
        loader.load('./glb/robot.glb', (gltf) => {
            if (version !== layoutVersion) return;
            const model = gltf.scene;
            model.traverse((child) => {
                if (!child.isMesh) return;
                // 骨骼父子鏈會讓 boundingSphere 以綁定空間計算而誤判裁剪
                child.frustumCulled = false;
                // 未命名材質是 metalness=1 的裸金屬，無環境貼圖會渲染成全黑；
                // 參數比照 exhibition.js 的調整值
                if (child.material && child.material.isMeshStandardMaterial &&
                    !(child.material.name || '').includes('CuteRobotFaceTexture')) {
                    const source = child.material;
                    const m = new THREE.MeshPhysicalMaterial();
                    m.name = source.name;
                    if (source.color) m.color.copy(source.color);
                    m.map = source.map;
                    m.lightMap = source.lightMap;
                    m.lightMapIntensity = source.lightMapIntensity;
                    m.aoMap = source.aoMap;
                    m.aoMapIntensity = source.aoMapIntensity;
                    m.emissiveMap = source.emissiveMap;
                    m.bumpMap = source.bumpMap;
                    m.bumpScale = source.bumpScale;
                    m.normalMap = source.normalMap;
                    if (source.normalScale) m.normalScale.copy(source.normalScale);
                    m.displacementMap = source.displacementMap;
                    m.displacementScale = source.displacementScale;
                    m.displacementBias = source.displacementBias;
                    m.roughnessMap = source.roughnessMap;
                    m.metalnessMap = source.metalnessMap;
                    m.alphaMap = source.alphaMap;
                    m.alphaTest = source.alphaTest;
                    m.opacity = source.opacity;
                    m.transparent = source.transparent;
                    m.side = source.side;
                    m.depthTest = source.depthTest;
                    m.depthWrite = source.depthWrite;
                    m.vertexColors = source.vertexColors;
                    m.flatShading = source.flatShading;
                    m.skinning = !!child.isSkinnedMesh;
                    m.morphTargets = source.morphTargets;
                    m.morphNormals = source.morphNormals;
                    m.toneMapped = source.toneMapped;
                    m.emissive = new THREE.Color(0x294651);
                    m.emissiveIntensity = 0.008;
                    const isMainShell = m.name === 'robot' && !!m.map;
                    if (isMainShell) {
                        // 珍珠灰白主外殼：低金屬、雙層清漆與微細霧面顆粒。
                        m.color.multiply(new THREE.Color(0xE0E7EC));
                        m.roughness = 0.42;
                        m.roughnessMap = shellSurface.roughnessTexture;
                        m.bumpMap = shellSurface.bumpTexture;
                        m.bumpScale = 0.014;
                        m.metalness = 0.035;
                        m.clearcoat = isLowPowerDevice ? 0.26 : 0.52;
                        m.clearcoatRoughness = 0.22;
                        m.reflectivity = 0.56;
                        m.envMapIntensity = 1.05;
                    } else {
                        // 耳罩、關節與小型硬件改為冷灰緞面，與白色外殼產生層次。
                        m.color.lerp(new THREE.Color(0xAEBBC5), 0.28);
                        m.roughness = 0.3;
                        m.metalness = Math.max(0.12, Math.min(source.metalness, 0.24));
                        m.clearcoat = isLowPowerDevice ? 0.18 : 0.34;
                        m.clearcoatRoughness = 0.16;
                        m.reflectivity = 0.52;
                        m.envMapIntensity = 1.12;
                    }
                    child.material = m;
                    // 'robot' 材質的貼圖含臉部格子，記下供表情切換。
                    // 注意：每個 mesh 各持有一份 clone，臉部視覺在唯一的
                    // skinned body mesh 上，必須記「那一份」clone
                    if (child.isSkinnedMesh && m.name === 'robot' && m.map) robotBodyMat = m;
                }
            });
            if (robotBodyMat) {
                robotFaceTexBase = robotBodyMat.map;
                robotFaceTexHappy = buildHappyTexture(robotFaceTexBase);
                const accentTexture = buildAccentEmissionTexture(robotFaceTexBase);
                if (accentTexture) {
                    robotBodyMat.emissiveMap = accentTexture;
                    robotBodyMat.emissive.set(0x55D3E9);
                    robotBodyMat.emissiveIntensity = 0.24;
                    robotBodyMat.needsUpdate = true;
                }
            }
            const hiddenBones = model.getObjectByName('Bone001');
            if (hiddenBones) hiddenBones.visible = false;
            robotHead = model.getObjectByName('Bone005');
            if (robotHead) robotHeadRest = { x: robotHead.rotation.x, y: robotHead.rotation.y, z: robotHead.rotation.z };
            robotArm = model.getObjectByName('Bone011');
            if (robotArm) robotArmRest = robotArm.quaternion.clone();
            model.scale.set(scale, scale, scale);
            model.position.set(x, y, 0);
            model.rotation.y = -0.3; // 微側身面向左側文字區
            scene.add(model);
            objects.push({ mesh: model, baseY: y, offset: Math.random() * 10 });
        });
    }

    // 深空星點：隨滑鼠視差微動，不參與漂浮
    function addStarfield() {
        const count = isLowPowerDevice ? 120 : 260;
        const positions = new Float32Array(count * 3);
        for (let i = 0; i < count; i++) {
            positions[i * 3] = (Math.random() - 0.5) * 22;
            positions[i * 3 + 1] = (Math.random() - 0.5) * 12;
            positions[i * 3 + 2] = -2 - Math.random() * 6;
        }
        const geo = new THREE.BufferGeometry();
        geo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
        const mat = new THREE.PointsMaterial({
            color: 0x91B8D3, size: 0.026, transparent: true, opacity: 0.48, sizeAttenuation: true
        });
        const stars = new THREE.Points(geo, mat);
        scene.add(stars);
        objects.push({ mesh: stars, baseY: 0, offset: 0, isStatic: true });
    }

    // 機器人的橢圓軌道環：呼應模型自身的懸浮環設計語言，
    // 並為衛星球的月牙隊形提供「軌道系統」的結構隱喻。
    // 傾斜後下緣會繞到機器人前方（土星環式自然遮擋）
    function addOrbitRing(x, y, radius, rotX, rotZ, ringOpacity) {
        const curve = new THREE.EllipseCurve(0, 0, radius, radius, 0, Math.PI * 2);
        const geo = new THREE.BufferGeometry().setFromPoints(curve.getPoints(96));
        const mat = new THREE.LineBasicMaterial({ color: 0x55C2F5, transparent: true, opacity: ringOpacity });
        const ring = new THREE.Line(geo, mat);
        ring.rotation.x = rotX;
        ring.rotation.z = rotZ;
        ring.position.set(x, y, 0);
        scene.add(ring);
        objects.push({ mesh: ring, baseY: y, offset: 0, isStatic: true });
    }

    let layoutVersion = 0;
    let currentMobile = null;
    let currentCompactMobile = null;
    let currentShortMobile = null;
    let currentWideLayout = null;
    let currentRightColX = null;

    function buildLayout() {
        layoutVersion++;
        robotHead = null;
        robotHeadRest = null;
        robotArm = null;
        robotArmRest = null;
        robotBodyMat = null;
        robotFaceTexBase = null;
        robotFaceTexHappy = null;
        faceHappy = false;
        touchHitMesh = null;
        hologramGroup = null;
        hologramMat = null;
        hologramFrameMat = null;
        hologramGlowMat = null;
        hologramBeamMat = null;
        hologramBeam = null;
        hologramPanelScale = 1;
        updateHologramBeam = null;
        hologramCanvas = null;
        hologramCtx = null;
        hologramTexture = null;
        activeProjection = null;
        projectionAmount = 0;
        techSpheres = [];
        objects.forEach((obj) => scene.remove(obj.mesh));
        objects = [];
        currentMobile = window.matchMedia(MOBILE_LAYOUT_QUERY).matches;
        useMobileComposition = currentMobile;
        if (currentMobile) {
            // DevTools 的平板模擬仍可能回報滑鼠指標；手機／平板構圖不可因
            // 游標視差整組偏移，否則右側卡片、機器人會被推出安全邊界。
            scene.rotation.set(0, 0, 0);
            targetRotation.set(0, 0);
        }
        currentCompactMobile = currentMobile &&
            (window.innerHeight <= 740 || (window.innerWidth / window.innerHeight) >= 0.62);
        currentShortMobile = currentMobile && window.innerHeight <= 700;
        currentWideLayout = !currentMobile && (window.innerWidth / window.innerHeight >= 1.95);
        // 桌機用長焦（FOV 32°）減少邊緣球體的透視橢圓變形；
        // 距離按 tan(fov/2)×z 反推，z=0 平面的取景範圍與原 45°/7.5 完全相同
        camera.fov = currentMobile ? 45 : 32;
        camera.position.z = currentMobile ? 10 : 10.83;
        camera.updateProjectionMatrix();

        // 桌機構圖：robot 為主角（右側焦點），六大服務衛星收攏成環繞
        // 機器人的雙層月牙——外弧 AI → 網站 → 數據 → 維運、內圈
        // 系統/資安——左半部文字區完全淨空，標題獨享視覺權重；
        // 手機仍為 stock 圖佈局。座標避開標題文字區（x < 0.5、y 0.2~1.5）
        if (!currentMobile) {
            addStarfield();
            loadRobot(currentWideLayout ? 2.78 : 2.55, -1.25, currentWideLayout ? 1.66 : 1.6);
            // 服務節點與 RURU 同步加大，右上保留一塊區域給 hover 科技投影。
            // 右欄卡片與投影面板依實際視口半寬鉗制 x：aspect ≥1.6（如 1440×900）
            // 等於設計值（保留貼邊出血），更窄（如 1024×768）整欄左收避免裁切
            const viewHalfW = 3.106 * (window.innerWidth / Math.max(1, window.innerHeight));
            const secX = Math.min(currentWideLayout ? 4.35 : 4.25, viewHalfW - 0.72);
            const holoX = Math.min(currentWideLayout ? 4.72 : 3.58, viewHalfW - 1.39);
            currentRightColX = secX;
            // 內收後資安卡的水平帶會與機器人頭部同高而被遮擋，
            // 鉗制生效時上移到頭頂（y≈0.4）與投影面板底緣（y≈0.97）之間
            const rightColClamped = secX < (currentWideLayout ? 4.35 : 4.25) - 0.01;
            const secY = rightColClamped ? 0.72 : (currentWideLayout ? 0.02 : 0.08);
            createTechSphere('AI', 1.48, 1.72, 0.88, 115, { x: 0.2, y: -0.5, z: -0.3 }, 0.8, 0.6);
            createTechSphere('網站', 0.72, 1.02, 0.79, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.5, 0.32);
            createTechSphere('系統', 0.9, 0.22, 0.79, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.55, 0.35);
            createTechSphere('數據', 0.62, -0.62, 0.79, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.45, 0.3);
            createTechSphere('資安', secX, secY, currentWideLayout ? 0.79 : 0.7, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.6, 0.4);
            createTechSphere('維運', secX - 0.17, currentWideLayout ? -1.38 : -1.48, currentWideLayout ? 0.79 : 0.72, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.4, 0.28);
            createHologramPanel(
                holoX,
                1.5,
                currentWideLayout ? 1 : 0.86
            );
        } else {
            // 手機直式構圖：所有 3D 元件落在 CTA 下方或右側安全區。
            // 短螢幕另用較緊湊的 y 座標，避免同一組世界座標在不同高度下穿進 CTA。
            addStarfield();
            if (currentShortMobile) {
                // iPhone SE 等 700px 以下裝置：首張卡避開 CTA，其餘卡片
                // 分置機器人兩側，底部仍為 SCROLL DOWN 保留安全距離。
                loadRobot(0.3, -2.55, 1.28);
                createTechSphere('網站', 1.3, -1.15, 0.54, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.5, 0.32);
                createTechSphere('AI', 1.3, -1.68, 0.55, 115, { x: 0.2, y: -0.5, z: -0.3 }, 0.8, 0.6);
                createTechSphere('數據', -1.34, -1.68, 0.54, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.45, 0.3);
                createTechSphere('資安', -1.36, -2.42, 0.55, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.6, 0.4);
                createTechSphere('系統', 1.28, -2.68, 0.52, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.55, 0.35);
                createTechSphere('維運', -1.2, -3.16, 0.51, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.4, 0.28);
            } else if (currentCompactMobile) {
                loadRobot(0.32, -2.4, 1.36);
                createTechSphere('網站', 1.36, -0.52, 0.58, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.5, 0.32);
                createTechSphere('AI', 1.36, -1.16, 0.59, 115, { x: 0.2, y: -0.5, z: -0.3 }, 0.8, 0.6);
                createTechSphere('數據', -1.42, -1.36, 0.58, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.45, 0.3);
                createTechSphere('資安', -1.44, -2.26, 0.59, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.6, 0.4);
                createTechSphere('系統', 1.34, -2.52, 0.56, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.55, 0.35);
                createTechSphere('維運', -1.28, -3.06, 0.55, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.4, 0.28);
            } else {
                loadRobot(0.1, -1.82, 1.45);
                createTechSphere('網站', 1.28, 0.35, 0.54, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.5, 0.32);
                createTechSphere('AI', 1.28, -0.42, 0.56, 115, { x: 0.2, y: -0.5, z: -0.3 }, 0.8, 0.6);
                createTechSphere('數據', -1.35, -0.62, 0.56, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.45, 0.3);
                createTechSphere('資安', -1.35, -1.62, 0.58, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.6, 0.4);
                createTechSphere('系統', 1.26, -1.92, 0.54, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.55, 0.35);
                createTechSphere('維運', -1.24, -2.78, 0.56, 120, { x: 0.2, y: -0.5, z: -0.3 }, 0.4, 0.28);
            }
        }
    }

    buildLayout();
    relayoutScene = function () {
        const nextMobile = window.matchMedia(MOBILE_LAYOUT_QUERY).matches;
        const nextCompactMobile = nextMobile &&
            (window.innerHeight <= 740 || (window.innerWidth / window.innerHeight) >= 0.62);
        const nextShortMobile = nextMobile && window.innerHeight <= 700;
        const nextWideLayout = !nextMobile && (window.innerWidth / window.innerHeight >= 1.95);
        // 右欄鉗制值隨視口寬高比連續變化，跨過閾值（差 >0.05）也要重排，
        // 否則從 1440 縮到 1024 不會觸發任何斷點切換、卡片停在被裁切的位置
        let rightColChanged = false;
        if (!nextMobile && currentRightColX !== null) {
            const nextHalfW = 3.106 * (window.innerWidth / Math.max(1, window.innerHeight));
            const nextSecX = Math.min(nextWideLayout ? 4.35 : 4.25, nextHalfW - 0.72);
            rightColChanged = Math.abs(nextSecX - currentRightColX) > 0.05;
        }
        if (nextMobile !== currentMobile ||
            nextCompactMobile !== currentCompactMobile ||
            nextShortMobile !== currentShortMobile ||
            nextWideLayout !== currentWideLayout ||
            rightColChanged) buildLayout();
    };
    const mobileQuery = window.matchMedia(MOBILE_LAYOUT_QUERY);
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', relayoutScene);
    else if (mobileQuery.addListener) mobileQuery.addListener(relayoutScene);

    scene.add(new THREE.AmbientLight(0xAFC8D8, 0.11));
    // 產品攝影式三點光：左上主光塑形、右前補光保留暗部細節、
    // 後方青藍輪廓光把白色機身從數位地球背景中分離。
    scene.add(new THREE.HemisphereLight(0xA5C8DB, 0x020713, 0.3));
    const keyLight = new THREE.DirectionalLight(0xF0F8FC, 0.82);
    keyLight.position.set(-4, 5, 7);
    scene.add(keyLight);
    const fillLight = new THREE.DirectionalLight(0x65AED0, 0.18);
    fillLight.position.set(5, -1, 5);
    scene.add(fillLight);
    const rimLight = new THREE.DirectionalLight(0x42BEEA, 0.5);
    rimLight.position.set(5, 3, -4);
    scene.add(rimLight);
    const lowerBounce = new THREE.PointLight(0x8DB3C5, 0.12);
    lowerBounce.position.set(1, -5, 4);
    scene.add(lowerBounce);

    // Banner 捲出視口後暫停渲染，省 GPU 與電量；回到視口再恢復
    const container = document.getElementById('container');
    if ('IntersectionObserver' in window && container) {
        new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) startLoop();
            else stopLoop();
        }).observe(container);
    } else {
        startLoop();
    }
}

function startLoop() {
    if (rafId === null) rafId = requestAnimationFrame(animate);
}

function stopLoop() {
    if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
    }
}

function animate() {
    rafId = requestAnimationFrame(animate);
    // 減少動態偏好：物件不漂浮、齒輪不轉、無滑鼠視差，維持靜態構圖
    if (!prefersReducedMotion) {
        const time = Date.now() * 0.001;
        objects.forEach((obj) => {
            if (obj.mesh && !obj.isStatic) {
                obj.mesh.position.y = obj.baseY + Math.sin(time + obj.offset) * 0.065;
            }
        });
        targetRotation.x = useMobileComposition ? 0 : mouse.y * 0.12;
        targetRotation.y = useMobileComposition ? 0 : mouse.x * 0.12;
        scene.rotation.x += (targetRotation.x - scene.rotation.x) * 0.05;
        scene.rotation.y += (targetRotation.y - scene.rotation.y) * 0.05;

        // 泡泡球 hover：命中的球放大並增亮邊緣光，離開後平滑復原。
        // 觸控裝置改用點擊狀態（含 2.5 秒時效），避免合成滑鼠事件造成永久 hover
        let hoveredService = null;
        if (techSpheres.length) {
            let hitObj = null;
            if (isCoarsePointer) {
                if (touchHitMesh && Date.now() < touchExpireAt) hitObj = touchHitMesh;
                else touchHitMesh = null;
            } else {
                raycaster.setFromCamera(mouse, camera);
                const hits = raycaster.intersectObjects(techSpheres.map((s) => s.hitMesh), false);
                hitObj = hits.length ? hits[0].object : null;
            }
            techSpheres.forEach((s) => {
                const isHit = (s.hitMesh === hitObj);
                if (isHit) {
                    hoveredService = s.service;
                }
                s.hover += ((isHit ? 1 : 0) - s.hover) * 0.12;
                const k = 1 + 0.08 * s.hover;
                s.group.scale.set(k, k, k);
                s.rimMat.opacity = Math.min(1, s.baseRimAlpha * (1 + 0.8 * s.hover));
                s.coreMat.opacity = Math.min(1, s.baseCoreOpacity * (1 + 0.12 * s.hover));
            });
        }
        renderer.domElement.style.cursor = hoveredService ? 'pointer' : 'default';

        // 六項服務各自投影不同介紹；面板以淡入與輕微放大呈現，
        // 不使用會穿過機器人的連接線。
        if (hologramGroup && hologramMat && hologramFrameMat && hologramGlowMat && hologramBeamMat) {
            if (hoveredService && hoveredService !== activeProjection) drawHologram(hoveredService);
            projectionAmount += ((hoveredService ? 1 : 0) - projectionAmount) * 0.14;
            hologramMat.opacity = projectionAmount * 0.96;
            hologramFrameMat.opacity = projectionAmount * 0.9;
            hologramGlowMat.opacity = projectionAmount * 0.11;
            hologramBeamMat.opacity = projectionAmount * 0.62;
            const projectionScale = 0.94 + projectionAmount * 0.06;
            hologramGroup.scale.set(projectionScale, projectionScale, projectionScale);
            hologramGroup.position.y = 1.5 + Math.sin(time * 1.7) * 0.012 * projectionAmount;
            if (hoveredService && updateHologramBeam) {
                updateHologramBeam(hoveredService, projectionScale);
            }
        }

        // 六項服務各自使用不同抬手幅度、歪頭方向與表情。
        const serviceMotion = hoveredService ? SERVICE_PRESENTATIONS[hoveredService] : null;
        const raiseTarget = serviceMotion ? serviceMotion.arm : 0;
        const wantHappy = !!(serviceMotion && serviceMotion.happy);
        if (robotBodyMat && robotFaceTexHappy && wantHappy !== faceHappy) {
            faceHappy = wantHappy;
            robotBodyMat.map = faceHappy ? robotFaceTexHappy : robotFaceTexBase;
        }

        armRaise += (raiseTarget - armRaise) * 0.1;
        if (robotArm && robotArmRest) {
            robotArm.parent.getWorldQuaternion(armParentQ);
            armAxis.set(0, 0, 1).applyQuaternion(armParentQ.invert()).normalize();
            armRot.setFromAxisAngle(armAxis, -armRaise);
            robotArm.quaternion.copy(robotArmRest).premultiply(armRot);
        }
        headTilt += (((serviceMotion && serviceMotion.tilt) || 0) - headTilt) * 0.1;

        // 頭部追蹤滑鼠：機器人約在畫面 NDC x≈0.5，游標在其左側時頭向左轉；
        // 骨骼局部軸實測：+y = 朝右、+x = 抬頭，角度鉗制避免不自然
        if (robotHead && robotHeadRest) {
            const targetYaw = Math.max(-0.55, Math.min(0.18, (mouse.x - 0.5) * 0.45));
            const targetPitch = Math.max(-0.15, Math.min(0.15, mouse.y * 0.18));
            headYaw += (targetYaw - headYaw) * 0.08;
            headPitch += (targetPitch - headPitch) * 0.08;
            robotHead.rotation.y = robotHeadRest.y + headYaw;
            robotHead.rotation.x = robotHeadRest.x + headPitch;
            robotHead.rotation.z = robotHeadRest.z + headTilt;
        }
    }
    renderer.render(scene, camera);
}

window.addEventListener('mousemove', (e) => {
    mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
});
// 觸控：點擊球體觸發與 hover 相同的反應（passive 不干擾捲動）；
// mouse 同步設為觸點，頭部追蹤與視差自然看向點擊處
window.addEventListener('touchstart', (e) => {
    if (!techSpheres.length || !camera) return;
    const t = e.touches[0];
    touchNdc.x = (t.clientX / window.innerWidth) * 2 - 1;
    touchNdc.y = -(t.clientY / window.innerHeight) * 2 + 1;
    mouse.x = touchNdc.x;
    mouse.y = touchNdc.y;
    raycaster.setFromCamera(touchNdc, camera);
    const hits = raycaster.intersectObjects(techSpheres.map((s) => s.hitMesh), false);
    if (hits.length) {
        touchHitMesh = hits[0].object;
        touchExpireAt = Date.now() + 2500;
        emitServiceDetail(touchHitMesh);
    } else {
        touchHitMesh = null;
    }
}, { passive: true });
window.addEventListener('click', (e) => {
    if (!renderer || e.target !== renderer.domElement ||
        !window.matchMedia(MOBILE_LAYOUT_QUERY).matches) return;
    touchNdc.x = (e.clientX / window.innerWidth) * 2 - 1;
    touchNdc.y = -(e.clientY / window.innerHeight) * 2 + 1;
    raycaster.setFromCamera(touchNdc, camera);
    const hits = raycaster.intersectObjects(techSpheres.map((s) => s.hitMesh), false);
    if (hits.length) emitServiceDetail(hits[0].object);
});
window.addEventListener('resize', () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
    if (relayoutScene) relayoutScene();
});
init();